import i18n from "i18n";
import DataTableVisualizationConfig from "views/logic/aggregationbuilder/visualizations/DataTableVisualizationConfig";
import DataTable from "./DataTable";
const dataTable = {
  type: DataTable.type,
  displayName: i18n.t("widgets:data_table.display_name"),
  component: DataTable,
  config: {
    createConfig: () => ({ pinnedColumns: [] }),
    fromConfig: (config) => {
      var _a, _b;
      return {
        pinnedColumns: (_a = config == null ? void 0 : config.pinnedColumns.toArray()) != null ? _a : [],
        showRowNumbers: (_b = config == null ? void 0 : config.showRowNumbers) != null ? _b : true
      };
    },
    toConfig: (formValues) => DataTableVisualizationConfig.create(formValues.pinnedColumns, formValues.showRowNumbers),
    fields: [
      {
        name: "pinnedColumns",
        title: i18n.t("widgets:data_table.pinned_columns_title"),
        type: "multi-select",
        options: ({ formValues }) => {
          var _a, _b;
          return (_b = (_a = formValues == null ? void 0 : formValues.groupBy) == null ? void 0 : _a.groupings.filter((grouping) => (grouping == null ? void 0 : grouping.direction) === "row" && (grouping == null ? void 0 : grouping.fields)).flatMap((grouping) => grouping.fields)) != null ? _b : [];
        },
        required: false
      },
      {
        name: "showRowNumbers",
        title: i18n.t("widgets:data_table.show_row_numbers_title"),
        type: "boolean"
      }
    ]
  }
};
export default dataTable;
